jQuery(document).ready(function($) {
    $('.send-reply').click(function(event) {
        event.preventDefault();

        var $form = $(this).closest('.reply-form');
        var replyText = $form.find('.reply-text').val();
        var commentId = $form.find('input[name="comment_id"]').val();
        var postId = $('#review_form').attr('data-post-id');

        $.ajax({
            type: 'POST',
            url: ajax_reply.ajax_url,
            data: {
                action: 'handle_reply',
                reply_text: replyText,
                comment_id: commentId,
                post_id: postId,
            },
            success: function(response) {
                if (response.success) {
                    $('#modal-success').addClass('open');
                    $('.review_reply__field').hide();
                    $form.find('.reply-text').val('');
                    setTimeout(function() {
                        $('#modal-success').removeClass('open');
                    }, 5000);
                }
            },
        });
    });
});
